import React, { useState, useEffect, useCallback } from 'react';
import OlCore from 'ol/OlCore';
import ObjectPolygon from 'ol/Object/ObjectPolygon';
import Logo from '../assets/images/logo.png';
import { getData, getFeatureData, request } from 'service/common';
import InfoBox from 'components/templates/_old/InfoBox/InfoBox';
import styled from 'styled-components';
import ObjectSite from '../ol/Object/ObjectSite';
import useGetGeoJson from '../hooks/map/useGetGeoJson';
import { paramsBuilder, requestGeoJson, urlBuilder } from '../ol/util';
import QuickMenu from '../components/templates/_old/Map/QuickMenu';
import PopupSiteInfo from '../components/templates/_old/Map/PopupSiteInfo';
import Toolbar from '../components/templates/_old/Map/Toolbar';
import RangeSlider from '../components/templates/_old/Map/RangeSlider';
import MapType from '../components/templates/_old/Map/MapType';
import MeasureModule from '../ol/Layer/MeasureModule';
import MapScale from '../components/templates/_old/Map/MapScale';
import ObjectHQ from '../ol/Object/ObjectHQ';
import IcoTool01 from 'assets/images/tool/ico-right-tool-1.svg';
import IcoTool02 from 'assets/images/tool/ico-right-tool-2.svg';
import IcoTool03 from 'assets/images/tool/ico-right-tool-3.svg';
import IcoTool04 from 'assets/images/tool/ico-right-tool-4.svg';
import IcoTool05 from 'assets/images/tool/ico-right-tool-5.svg';
import IcoTool01Active from 'assets/images/tool/ico-right-tool-1-active.svg';
import IcoTool02Active from 'assets/images/tool/ico-right-tool-2-active.svg';
import IcoTool03Active from 'assets/images/tool/ico-right-tool-3-active.svg';
import IcoTool04Active from 'assets/images/tool/ico-right-tool-4-active.svg';
import IcoTool05Active from 'assets/images/tool/ico-right-tool-5-active.svg';
import IcoLogin from 'assets/images/button/ico-login.svg';
import ClusterOverlay from '../components/templates/_old/Map/ClusterOverlay';
import { Feature } from 'ol';
import IcoMovements from '../assets/images/_old/quick/ico-movements.svg';
import IcoBusiness from '../assets/images/_old/quick/ico-business.svg';
import IcoKwater from '../assets/images/_old/quick/ico-kwater.svg';
import IcoKepco from '../assets/images/quick/ico-kepco.svg';
import IcoSpace from '../assets/images/_old/quick/ico-space.svg';
import ObjectWater from '../ol/Object/ObjectWater';
import ObjectSpace from '../ol/Object/ObjectSpace';
import ObjectPoint from '../ol/Object/ObjectPoint';
import PointInfoBox from '../components/templates/_old/InfoBox/PointInfoBox';
import query from '../hooks/RQuery/utils';
import queryKeys from '../hooks/RQuery/keys/queryKeys';
import Login from '../components/templates/_old/Map/Login';
import axios from 'axios';
import { getBubunByPnu } from 'service/multiPolygon';
import ImgTest from '../components/templates/_old/ImgTest';
import OpenImage from '../components/templates/_old/Container/OpenImage';
import ObjectPhoto from '../ol/Object/ObjectPhoto';
import { transWgsTo5186 } from 'ol/projection';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { loaderState } from 'store/Atoms';
import { flushSync } from 'react-dom';
import LeftToolGroup from '../components/templates/LeftToolGroup';
import Button from '../components/atoms/Button';
import PopupTemp from '../Popups/PopupTemp';
import Table from '../components/atoms/Table';
import Input from '../components/atoms/Input';
import PopupSiteAdd from '../Popups/PopupSiteAdd';
import PopupLandInfo from '../Popups/PopupLandInfo';
import PopupPointList from '../Popups/PopupPointList';
import { useNavigate } from 'react-router-dom';
import useLogInOut from '../hooks/useLogInOut';
import useSessionStorage from '../hooks/useSessionStorage';
import dummyData from '../assets/전북.json';
import dummyData2 from '../assets/경북2.json';

const ZoomLevelSt = {
  Wrap: styled.div`
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    background-color: #fff;
    display: none;
  `,
  Logo: styled.h1`
    position: absolute;
    z-index: 2;
    left: 0;
    top: 0;
    width: 300px;
    height: 110px;
    background: url(${Logo}) no-repeat center;
    background-size: cover;
    margin-bottom: 20px;
    border-radius: 18px;
    box-shadow: 4px 4px 27px 6px #21424e08;
    cursor: pointer;
  `,
};
function Map(props) {
  const navigate = useNavigate();
  const [popupState, setPopupState] = useState({
    siteAdd: false,
  });
  const { onLogInOut } = useLogInOut();
  const [menuList, setMenuList] = useState([
    { id: 0, name: '무브먼츠', active: false, ico: IcoMovements, layerId: ['hqLayer'], user: false },
    { id: 1, name: '무브먼츠 사업권역', active: false, ico: IcoBusiness, layerId: ['movePolygonLayer', 'movePointLayer'], user: true },
    { id: 2, name: '한국수자원공사', active: false, ico: IcoKwater, layerId: ['waterLayer'], user: false },
    // { id: 3, name: '한국전력공사', active: false, ico: IcoKepco, layerId: ['22'] },
    { id: 4, name: '공간DB 사업', active: false, ico: IcoSpace, layerId: ['spacePolygonLayer', 'spaceCenterLayer', 'spacePointLayer'], user: true },
  ]);
  const { value } = useSessionStorage('role');
  const [mapInstance, setMapInstance] = useState<OlCore>();
  const [objectPolygon, setObjectPolygon] = useState<ObjectPolygon>();
  const [objectSite, setObjectSite] = useState<ObjectSite>();
  const [objectPoint, setObjectPoint] = useState<ObjectPoint>();
  const [objectPhoto, setObjectPhoto] = useState<ObjectPhoto>();
  const [addressList, setAddressList] = useState<any>([]);
  const [measure, setMeasure] = useState<MeasureModule>();
  const [measureStatus, setMeasureStatus] = useState(false);
  const [measureType, setMeasureType] = useState<'Polygon' | 'LineString'>('Polygon');
  const [mapScaleNum, setMapScaleNum] = useState('0 m');
  const [popState, setPopState] = useState(false);
  const [siteData, setSiteData] = useState<any>(undefined);
  const [property, setProperty] = useState({});
  const [isInfoState, setIsInfoState] = useState<boolean>(false);
  const [bubunList, setBubunList] = useState<any>([]);
  //툴바 버튼 on/off
  const [toolList, setToolList] = useState([
    { id: 0, name: '영상선택', active: false, ico: IcoTool01, icoActive: IcoTool01Active },
    { id: 1, name: '지적도', active: false, ico: IcoTool02, icoActive: IcoTool02Active },
    { id: 2, name: '거리', active: false, ico: IcoTool03, icoActive: IcoTool03Active },
    { id: 3, name: '면적', active: false, ico: IcoTool04, icoActive: IcoTool04Active },
    { id: 4, name: '조회', active: false, ico: IcoTool05, icoActive: IcoTool05Active },
  ]);
  const [isPointDistance, setIsPointDistance] = useState(true);
  const [overlayState, setOverlayState] = useState(false);
  const [clusterFeatureList, setClusterFeatureList] = useState([]);
  const [modifyData, setModifyData] = useState({
    layerName: '',
    featureId: null,
    coordinates: [],
    type: '',
    srid: null,
  });
  const [zoom, setZoom] = useState(7.751621106338325);
  const [bbox, setBbox] = useState({
    minX: 0,
    minY: 0,
    maxX: 0,
    maxY: 0,
  });
  let isObjectReady = !!objectPolygon;

  const { mutate: mutateModify } = query.map.useModifyLayer(modifyData);

  useEffect(() => {
    if (isObjectReady) {
      if ('geolocation' in navigator) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const coord = transWgsTo5186([position.coords.longitude, position.coords.latitude]);
            mapInstance?.moveToPointCoord(coord);
            console.log(coord);
          },
          (error) => {
            console.error('위치 가져오기 실패:', error.message);
          },
          { enableHighAccuracy: true },
        );
      }
    }
  }, [isObjectReady]);

  // //Openlayers 초기화
  useEffect(() => {
    if (!document.querySelector('#mapContainer > .ol-viewport')) {
      const core = new OlCore();
      const objectPolygon = new ObjectPolygon(core);
      const objectSite = new ObjectSite(core);
      const objectPoint = new ObjectPoint(core);
      const objectPhoto = new ObjectPhoto(core);
      const measure = new MeasureModule(core);

      setMapInstance(core);
      setObjectPolygon(objectPolygon);
      setObjectSite(objectSite);
      setObjectPoint(objectPoint);
      setObjectPhoto(objectPhoto);
      setMeasure(measure);
    }
  }, []);

  // wfs 구역 경계
  useEffect(() => {
    if (isObjectReady) {
      objectPolygon?.drawSido(); //시도
      objectPolygon?.drawSigungu(); // 시군구
      objectPolygon?.drawEmd(); // 읍면동

      // objectMeasure?.addEvent(); // measure 이벤트 추가

      //  mapInstance?.getMapInstance()?.getView()?.setZoom(22);
      mapInstance?.onMoveEnd(() => {
        setMapScaleNum(document.getElementsByClassName('ol-scale-line-inner')[0].innerHTML || '0 m');
        console.log(mapInstance?.getMapInstance().getView().getViewStateAndExtent());
        setZoom(mapInstance?.getMapInstance().getView().getViewStateAndExtent().viewState.zoom);
        setBbox({
          minX: mapInstance?.getMapInstance().getView().getViewStateAndExtent().extent[0],
          minY: mapInstance?.getMapInstance().getView().getViewStateAndExtent().extent[1],
          maxX: mapInstance?.getMapInstance().getView().getViewStateAndExtent().extent[2],
          maxY: mapInstance?.getMapInstance().getView().getViewStateAndExtent().extent[3],
        });
      });
    }
  }, [isObjectReady]);

  // 지적도 on/off state 추가
  useEffect(() => {
    if (isObjectReady) {
      objectPolygon?.drawBubun(toolList[1].active, setBubunList); // 연속지적도
      // objectPolygon?.drawBubun2(); // 연속지적도 WFS /ned/wfs/~
    }
  }, [isObjectReady, toolList[1].active]);

  //측정
  useEffect(() => {
    measure?.destroy(measureStatus);
    measure?.addInteraction(measureStatus, measureType, isPointDistance);
  }, [measureStatus, measureType, isPointDistance]);

  const [points, setPoints] = useState<Feature[]>([]);
  const onPopupState = (key: string) => {
    setPopupState({ ...popupState, [key]: !popupState[key] });
  };

  console.log(mapInstance?.getMapInstance().getView());

  useEffect(() => {
    if (isObjectReady && dummyData) {
      // objectPoint?.addGeoJson5174(dummyData);
    }
  }, [isObjectReady, dummyData]);

  useEffect(() => {
    if (isObjectReady && dummyData2) {
      // objectPoint?.addGeoJson5186(dummyData2);
    }
  }, [isObjectReady, dummyData2]);

  return (
    <>
      {/*<button*/}
      {/*  type="button"*/}
      {/*  onClick={() => {*/}
      {/*    mapInstance?.toggleProjection('EPSG:5186');*/}
      {/*    console.log('1');*/}
      {/*  }}*/}
      {/*>*/}
      {/*  5186*/}
      {/*</button>*/}
      {/*<button*/}
      {/*  type="button"*/}
      {/*  onClick={() => {*/}
      {/*    mapInstance?.toggleProjection('EPSG:5174');*/}
      {/*    console.log('2');*/}
      {/*  }}*/}
      {/*>*/}
      {/*  5174*/}
      {/*</button>*/}
      {/* 정사영상 업로드 테스트용 input*/}
      <div style={{ width: '100%', height: '100%', position: 'relative' }} id={'mapContainer'}>
        <ZoomLevelSt.Logo></ZoomLevelSt.Logo>
        <RangeSlider mapInstance={mapInstance} />
        {/*<MapType mapInstance={mapInstance} />*/}
        {/*<QuickMenu*/}
        {/*  mapInstance={mapInstance}*/}
        {/*  onMoveNation={onInit}*/}
        {/*  menuList={menuList}*/}
        {/*  setMenuList={setMenuList}*/}
        {/*  pointMenuList={pointMenuList}*/}
        {/*  setPointMenuList={setPointMenuList}*/}
        {/*  onInit={onInit}*/}
        {/*  onToggleLayer={onToggleLayer}*/}
        {/*  objectPhoto={objectPhoto}*/}
        {/*  loginStatus={loginStatus}*/}
        {/*  onChangeLocalTileLayer={onChangeLocalTileLayer}*/}
        {/*  tileMap={tileMap}*/}
        {/*  resetTileLayer={resetTileLayer}*/}
        {/*  toggleTileLayer={toggleTileLayer}*/}
        {/*/>*/}
        <Toolbar toolList={toolList} setToolList={setToolList} mapInstance={mapInstance} setProperty={setProperty} setMeasureStatus={setMeasureStatus} setMeasureType={setMeasureType} />
        {/*{popState ? <PopupSiteInfo onClosePopup={onInit} setPopState={setPopState} siteData={siteData} mapInstance={mapInstance} menuList={menuList} /> : null}*/}
        {/*<MapScale mapScaleNum={mapScaleNum} id={'scaleBar'} />*/}
        {/*<ZoomLevel />*/}
        {/*<InfoBox property={property} active={toolList[0].active && !!Object.keys(property).length} isInfoState={isInfoState} onCloseInfo={onCloseInfo} />*/}

        {/*{points.length ? <PointInfoBox points={points} close={closeInfoBox} addressList={addressList} /> : null}*/}
        {/*<ClusterOverlay mapInstance={mapInstance} list={clusterFeatureList} overlayStatus={overlayState} setOverlayStatus={setOverlayState} objectSite={objectSite} setPopState={setPopState} setSiteData={setSiteData} />*/}

        {/*/!* TODO 정식 운영시 삭제*!/*/}
        <div style={{ position: 'fixed', zIndex: 2, bottom: 40, left: '50%', fontSize: 20, transform: 'translateX(-50%)', width: 'max-content', color: 'rgba(255,255,255,.8)', fontFamily: 'NanumGothic' }}>
          지오맵프로에서 임시로 운영중인 지도서비스 입니다.
        </div>
        <Button
          $isGradientBtn={true}
          $isTabButton={true}
          text={!!sessionStorage.getItem('token') ? 'LOGOUT' : 'LOGIN'}
          width={!!sessionStorage.getItem('token') ? 134 : 117}
          height={48}
          style={{ position: 'fixed', right: 20, top: 20, zIndex: 2 }}
          $leftIco={IcoLogin}
          $icoSize={24}
          $icoSpacing={6}
          onClick={onLogInOut}
        />
        <LeftToolGroup
          mapInstance={mapInstance}
          objectPoint={objectPoint}
          objectPolygon={objectPolygon}
          isObjectReady={isObjectReady}
          setPoints={setPoints}
          onPopupState={onPopupState}
          objectPhoto={objectPhoto}
          objectSite={objectSite}
          zoom={zoom}
          bbox={bbox}
        />
        <Button $isGradientBtn={true} $isTabButton={true} text={'HELP/게시판'} width={126} height={48} style={{ position: 'fixed', left: 20, bottom: 20, zIndex: 2 }} onClick={() => navigate('/board')} />
        {value === 'ADMIN' && <Button $isGradientBtn={true} $isTabButton={true} text={'관리자용'} width={126} height={48} style={{ position: 'fixed', left: 160, bottom: 20, zIndex: 2 }} onClick={() => navigate('/admin')} />}
        {popupState.siteAdd ? <PopupSiteAdd onPopupState={onPopupState} /> : null}
        {/*미사용*/}
        {/*<PopupLandInfo />*/}
        {points.length ? <PopupPointList points={points} objectPoint={objectPoint} setPoints={setPoints} /> : null}
        {bubunList.length ? <PopupLandInfo list={bubunList} objectPolygon={objectPolygon} setList={setBubunList} /> : null}
      </div>
    </>
  );
}

export default Map;

export function ZoomLevel() {
  return <ZoomLevelSt.Wrap id="zoomLevel"></ZoomLevelSt.Wrap>;
}
